<template>
  <div class="live_apply_box my_container">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>发布视频</span>
        <el-divider></el-divider>
      </p>
    </div>
    <el-form class="" method="POST" :model="apply" :rules="rules" label-position="left" label-width="70px" :hide-required-asterisk=true ref="registerForm" @submit.prevent="submitForm" :status-icon=true >
     <el-form-item label="视频标题" prop="video_title">
          <el-input type="text" v-model="apply.video_title"></el-input>
      </el-form-item>
      <el-form-item label="视频简介" prop="video_introduce">
          <el-input type="textarea" v-model="apply.video_introduce"></el-input>
      </el-form-item>
      <el-form-item label="所属板块" prop="nav_id">
        <el-cascader class="el-select"
        v-model = "apply.model_arr"
        :options="modelOptionsList"
        :props="modelProps"
        @change="modelChange">
        </el-cascader>
      </el-form-item>
      <el-form-item label="添加标签" prop="tag_id_arr">
        <el-select
            v-model="apply.tag_id_arr"
            multiple
            filterable
            default-first-option
            :multiple-limit = 5
            placeholder="请选择文章标签">
            <el-option
              v-for="item in labelOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="视频上传" prop="video_upload">
        <video-view v-if="fileView" :videotype="videoType" :videourl="apply.url"  @files = "filesUrl"></video-view>
      </el-form-item>
      <el-form-item label="封面上传" prop="video_upload">
        <img-view :filestype="filestype" :imgurl="apply.img" @files = "imgUrl"></img-view>
      </el-form-item>
      <div class="train_price" v-show="apply.nav_id === 14">
        <el-form-item label="费用">
          <el-radio v-model="apply.price_onoff" label="1">免费</el-radio>
          <el-radio v-model="apply.price_onoff" label="2">收费</el-radio>
        </el-form-item>
        <el-form-item v-show="apply.price_onoff === '2'" label="收费金额" prop="price">
          <el-input
            placeholder="请输入收费金额"
            v-model="apply.price">
          </el-input>
        </el-form-item>
      </div>
      <el-form-item label="视频类型" prop="type">
        <el-select v-model="apply.type" placeholder="请选择视频类型">
          <el-option label="请选择" value=""></el-option>
          <el-option label="原创" value="1"></el-option>
          <el-option label="转载" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="apply.type === '2'" label="转载地址" prop="address">
        <el-input v-model="apply.address" placeholder="请填写转载地址或媒体"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="rg_form_box_form_item">
          <el-button type="primary" class="rg_form_box_form_sub" @click="submitForm('registerForm')">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import videoUpload from '../Public/videoUpload.vue'
import imgUpload from '../Public/imgUpload.vue'
export default {
  components: {
    videoView: videoUpload,
    imgView: imgUpload
  },
  data () {
    return {
      labelOptions: [], // 标签
      modelProps: { // 板块选择器配置
        value: 'id',
        label: 'name',
        children: 'model'
      },
      modelOptionsList: [], // 板块选择数组
      apply: {
        video_title: '',
        video_introduce: '',
        model_arr: [], // 模块绑定数组
        nav_id: '',
        union_id: '', // 联盟id
        research_id: '', // 研究院id
        tag_id_arr: '', // 标签数组
        tag_id: '',
        field_id: '', // 上传文件id
        url: '', // 地址
        img: '', // 视频封面
        price_onoff: '', // 是否免费
        price: '', // 金额
        type: '', // 文章类型 1原创 2转载
        address: '' // 转载地址
      },
      rules: {
        video_title: [{ required: true, message: '请输入视频标题', trigger: 'blur' }],
        video_introduce: [{ required: true, message: '请输入视频简介', trigger: 'blur' }],
        nav_id: [{ required: true, message: '请选择板块', trigger: 'blur' }],
        tag_id_arr: [{ required: true, message: '请至少选择一个标签', trigger: 'blur' }],
        type: [{ required: true, message: '文章类型不能为空', trigger: 'blur' }],
        price: [
          {
            validator: (rule, value, callback) => {
              if (this.apply.price_onoff === '2') {
                if (value === '') {
                  callback(new Error('费用金额不能为空'))
                } else {
                  const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
                  console.log(reg.test(value))
                  if (!reg.test(value)) {
                    callback(new Error('请输入正确额格式,可保留两位小数'))
                  } else {
                    callback()
                  }
                }
              } else {
                callback()
              }
            }
          }
        ],
        address: [
          {
            validator: (rule, value, callback) => {
              if (this.apply.type === '2') {
                if (value === '') {
                  callback(new Error('转载地址不能为空'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ]
      },
      pickerOptions0: { // 限制日期
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      fileView: true,
      videoType: 'video',
      filestype: 'liveBackground'
    }
  },
  created () {
    const vueThat = this
    const id = vueThat.$route.query.id
    this.getModel()
    vueThat.myApi.getLabel().then(function (res) {
      if (res.data.code === 200) {
        vueThat.labelOptions = res.data.data
        vueThat.$nextTick(function () {
          if (id !== undefined) {
            vueThat.myApi.videoDetail({ video_id: id }).then((res) => {
              if (res.data.code === 200) {
              }
            })
          } else {
            vueThat.fileView = true
          }
        })
      }
    })
  },
  methods: {
    // 获取选择模块
    getModel () {
      const vueThat = this
      const typeId = 2
      vueThat.myApi.getModel({ type_id: typeId }).then(function (res) {
        if (res.data.code === 200) {
          const navList = res.data.data.nav_list
          const unionList = res.data.data.union_list
          const researchList = res.data.data.research_list
          for (let i = 0; i < navList.length; i++) {
            const model = navList[i].model
            for (let n = 0; n < model.length; n++) {
              const sonModel = model[n].model
              if (sonModel !== undefined && sonModel.length > 0) {
                for (let m = 0; m < sonModel.length; m++) {
                  if (sonModel[m].is_use === 0) {
                    sonModel[m].name += '(暂不支持)'
                    sonModel[m].disabled = true
                  }
                }
              } else {
                if (model[n].is_use === 0) {
                  model[n].name += '(暂不支持)'
                  model[n].disabled = true
                }
              }
            }
          }
          if (unionList.length > 0 && navList[1].model.length > 0) {
            for (let i = 0; i < unionList.length; i++) {
              unionList[i].model = navList[1].model
            }
            navList[1].model = unionList
          } else {
            navList[1].disabled = true
          }
          if (researchList.length > 0 && navList[2].model.length > 0) {
            for (let i = 0; i < researchList.length; i++) {
              researchList[i].model = navList[2].model
            }
            navList[2].model = researchList
          } else {
            navList[2].disabled = true
          }
          vueThat.modelOptionsList = navList
        }
      })
    },
    // 模块选定后的回调
    modelChange (value) {
      if (value.length > 0) {
        if (value[0] === 3) {
          this.apply.union_id = value[1]
          this.apply.nav_id = value[2]
        } else if (value[0] === 4) {
          this.apply.research_id = value[1]
          this.apply.nav_id = value[2]
        } else {
          this.apply.nav_id = value[1]
        }
      }
    },
    // 获取视频文件地址
    filesUrl: function (id, url) {
      this.apply.field_id = id
      this.apply.url = url
      console.log(id)
      console.log(url)
    },
    // 获取视频封面地址
    imgUrl: function (data) {
      this.apply.img = data
      console.log(data)
    },
    // 提交
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        console.log(valid)
        if (valid) {
          try {
            vueThat.apply.tag_id = vueThat.apply.tag_id_arr.join(',')
            if (vueThat.apply.url === '') {
              vueThat.$alert('请上传视频', '温馨提示', {
                confirmButtonText: '确定',
                showClose: false
              })
            } else {
              await vueThat.myApi.videoSub(vueThat.apply)
                .then(function (res) {
                  if (res.data.code === 200) {
                    vueThat.$alert('提交申请成功，请耐心等待审核通过', '温馨提示', {
                      type: 'success',
                      iconClass: 'iconfont icon-icon_richeng_btn_pass',
                      confirmButtonText: '确定',
                      showClose: false,
                      callback: action => {
                        vueThat.$store.commit('editPersonalMeunAct', 'userVideoList')
                        vueThat.$router.push({ name: 'UserVideoList' })
                      }
                    })
                  }
                })
            }
          } catch (e) {}
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
</style>
